<!-- BUSCA -->
<ion-toolbar class="barra-busca">
  <div class="searchAndButton">
    <ion-item lines="none" class="box-busca">

      <ion-input class="input-busca" placeholder="BUSCAR PRODUTO" (keyup.enter)="buscar()" [(ngModel)]="formBusca.busca"
        [ngModelOptions]="{standalone: true}">
      </ion-input>

    </ion-item>

    <ion-button slot="end" class="btn-buscar" color="primary" (click)="buscar()">
      <ion-icon slot="icon-only" name="search"></ion-icon>
    </ion-button>

  </div>
  <ion-button slot="start" color="primary" class="btn-filtro" (click)="showCategorias = !showCategorias">
    <ion-icon slot="icon-only" [name]="showCategorias ? 'apps' : 'ellipsis-vertical'"></ion-icon>
  </ion-button>

</ion-toolbar>

<!-- BANNER 01 -->
<ion-img class="ion-margin-top" *ngIf="vitrine !== null && vitrine.banner_1.img !== ''" [src]="vitrine.banner_1.img">
</ion-img>

<!-- MENU CATEGORIAS -->
<ion-list class="menuFiltros" *ngIf="showCategorias">

  <div *ngFor="let categoria of categorias">

    <ion-item button="true" color="primary" (click)="toggleGroup(categoria)">
      <div class="item-text-center item-text-wrap">{{categoria.name}}</div>
      <ion-icon slot="end" [name]="isGroupShown(categoria) ? 'caret-up' : 'caret-down'"></ion-icon>
    </ion-item>

    <div *ngIf="isGroupShown(categoria)">

      <ion-item button="true" class="item-accordion item-icon-right" *ngFor="let item of categoria.subcategories"
        (click)="abreSubcategoria('categoria', item)">
        <div class="item-text-center item-text-wrap">{{item.name}}</div>
      </ion-item>

    </div>

  </div>

</ion-list>
